(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("autobind", [], factory);
	else if(typeof exports === 'object')
		exports["autobind"] = factory();
	else
		root["autobind"] = factory();
})(this, function() {
return 